export enum MessageForm {
  SELECT = 'Select what types of emails this user wants to receive.',
}
